export default "__VITE_ASSET__BU3lxHvu__"